var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.preferencesRequired)?_c('j-alert',{attrs:{"type":"warning","icon":"mdi-lightbulb-on-outline"}},[_vm._v(" You must "),_c('router-link',{staticClass:"warning--text font-weight-bold",attrs:{"to":"/account/preferences"}},[_vm._v(" complete your preferences ")]),_vm._v(" to get the correct portion and calorie recommendations ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }